import { Api, ContactRequest } from '../api/BackofficeApi';

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://backoffice-api.enerjet.co.il'
  : 'http://localhost:9091';

const api = new Api({ baseUrl: API_BASE_URL });

export const contactAPI = {
  submitContact: async (data: ContactRequest) => {
    await api.contact.submitContact(data);
  },
};
